import { Component } from '@angular/core';
import { MemberService } from '../member-service/MemberService ';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatHint } from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { ToastService } from '../../services/toast.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { formatDate } from '@angular/common';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
declare var $: any;


@Component({
  selector: 'app-member-medication',
  templateUrl: './member-medication.component.html',
  standalone: true,
  imports: [MatTableModule, CommonModule, FormsModule, MatPaginatorModule, MatPaginator, MatDatepickerModule,
    MatHint, MatLabel, MatFormFieldModule, MatDateRangeInput, MatNativeDateModule, MatInputModule],
  styleUrls: ['./member-medication.component.css']
})


export class MemberMedicationComponent {
  memberId: any;
  timeZone: any;
  dataSource = new MatTableDataSource<any>;
  medList: any = [];
  editList: any = [];
  medSelectedDate: any;
  editMedObj: any = {};
  isEdit: boolean = false;
  memCurDate: any;
  displayedColumns: string[] = ['Medications', 'MedTime', 'Dosage', 'Quantity', 'Frequency', 'StartDate', 'Status', 'Update'];

  // Add medication properties
  newMedObj: any = {
    name: '',
    frequency: '',
    dosage: null,
    unit: '',
    startDate: null,
    medications: [{ time: '', quantity: null }]
  };
  minStartDate: Date = new Date(); // Restrict start date to today or later

  constructor(private toast: ToastService, private memberService: MemberService, private route: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('id') || '';
    this.memberService.getMemberById(this.memberId).subscribe(data => {
      this.timeZone = data.result.timeZone;
    });
    var date = new Date().toISOString().split('T')[0];
    this.medSelectedDate = new Date();
    this.memCurDate = formatDate(new Date(new Date().toLocaleString("en-US", { timeZone: this.timeZone })), 'yyyy-MM-dd', 'en-US');
    this.getMedicines(date, false);
    this.getMedicines(this.memCurDate, true);
  }

  getMedicines(date: any, isEdit: boolean) {
    this.memberService.getMedicines(this.memberId, date, isEdit).subscribe(response => {
      this.medList = response;
      if (isEdit) {
        this.editList = this.medList['editMedicines'];
        if (this.medList['editMedicines'].length == 0 && this.isEdit) {
          this.toast.infoMessage("No medicine found to edit");
        }
      } else {
        var medsToShow: any[] = [];
        this.dataSource = new MatTableDataSource<any>(medsToShow);
        if (this.medList['medicines'].length == 0) {
          this.toast.infoMessage("No medicine found for the selected date");
        } else {

          var meds = this.medList['medicines'];
          for (let med of meds) {
            var medSDate = med.startDate.split('T')[0];
            var startDate = new Date(medSDate.split('-')[0], medSDate.split('-')[1] - 1, medSDate.split('-')[2]);
            var selDate = new Date(date.split('-')[0], date.split('-')[1] - 1, date.split('-')[2]);
            startDate.setHours(0, 0, 0, 0);
            selDate.setHours(0, 0, 0, 0);
            let includeMed = false;
            if (med.frequency == 'Weekly') {
              const diffDays = Math.floor((selDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
              includeMed = diffDays % 7 === 0 && diffDays >= 0;
            } else if (med.frequency == 'Every 15 Days') {
              const diffDays = Math.floor((selDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
              includeMed = diffDays % 15 === 0 && diffDays >= 0;
            } else if (med.frequency == 'Every 6 Months') {
              const diffMonths =
                (selDate.getFullYear() - startDate.getFullYear()) * 12 +
                (selDate.getMonth() - startDate.getMonth());
              includeMed = diffMonths % 6 === 0 && diffMonths >= 0 &&
                selDate.getDate() === startDate.getDate();
            } else {
              includeMed = true;
            }
            if (includeMed) {
              const displayTime = med.status?.takenTime && med.status?.takenTime.trim() !== ''
                ? med.status.takenTime
                : med.time;
              const editableTime = this.convertToTimeInput(displayTime);
              const editableStatus = med.status?.status || '';
              const statusRecId = med.status?.recId || med.recId || '';
              medsToShow.push({
                ...med,
                time: displayTime,
                editableTakenTime: editableTime,
                editableStatus: editableStatus,
                statusRecId: statusRecId
              });
            }
          }
        }
      }
    });
  }
  extractMedicines(medDateRange: any) {
    const selectedDate = medDateRange.value;
    this.getMedicines(formatDate(selectedDate, 'yyyy-MM-dd', 'en-US'), false);
    this.getMedicines(this.memCurDate, true);
  }

  editMeds() {
    this.isEdit = !this.isEdit;
    this.editList = [];
    this.getMedicines(this.memCurDate, true);
  }

  viewMeds() {
    this.isEdit = !this.isEdit;
    this.dataSource = new MatTableDataSource<any>;
    this.getMedicines(formatDate(this.medSelectedDate, 'yyyy-MM-dd', 'en-US'), false);
    this.getMedicines(this.memCurDate, true);
  }

  openEditMedModal(med: any) {
    this.editMedObj = JSON.parse(JSON.stringify(med));
    this.editMedObj.medicines.forEach((m: any) => {
      if (m.time) {
        m.time = new Date(`1970-01-01 ${m.time}`).toTimeString().slice(0, 5);
      }
    });
    $('#editMedModal').modal('show');
  }

  openDelModal(med: any) {
    this.editMedObj = JSON.parse(JSON.stringify(med));
    $('#delMedModal').modal('show');
  }

  onFreqChange() {
    if (this.editMedObj.frequency == 'Once daily' || this.editMedObj.frequency == 'Weekly'
      || this.editMedObj.frequency == 'Every 15 Days' || this.editMedObj.frequency == 'Every 6 Months') {
      if (this.editMedObj.medicines.length > 1) {
        this.editMedObj.medicines = [this.editMedObj.medicines[0]];
      }
    } else if (this.editMedObj.frequency == 'Twice daily') {
      if (this.editMedObj.medicines.length < 2) {
        this.editMedObj.medicines.push({ time: '', quantity: 1 });
      } else if (this.editMedObj.medicines.length > 2) {
        this.editMedObj.medicines = this.editMedObj.medicines.slice(0, 2);
      }
    }
    else if (this.editMedObj.frequency == 'Thrice daily') {
      if (this.editMedObj.medicines.length < 2) {
        this.editMedObj.medicines = [{ ...this.editMedObj.medicines[0] }, { time: '', quantity: 1 }, { time: '', quantity: 1 }];
      } else if (this.editMedObj.medicines.length < 3) {
        this.editMedObj.medicines.push({ time: '', quantity: 1 });
      }
    }
  }
  updateMed() {
    var medObj = this.editMedObj.medicines[0];
    if (this.editMedObj.medicines.length > 1) {
      for (var i = 1; i < this.editMedObj.medicines.length; i++) {
        var m = this.editMedObj.medicines[i];
        m.dosage = medObj.dosage;
        m.name = medObj.name;
        m.unit = medObj.unit;
      }

    }
    var obj = {
      id: this.editMedObj.id,
      memberId: this.editMedObj.memberId,
      curDate: this.memCurDate,
      frequency: this.editMedObj.frequency,
      medications: this.editMedObj.medicines
    };

    if (!this.validateMed(obj)) {
      return;
    }
    obj.medications.forEach((m: any) => {
      if (m.time) {
        m.time = formatDate(new Date(`1970-01-01 ${m.time}`), 'hh:mm a', 'en-US');
      }
    });
    this.memberService.updateMedicine(obj).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage("Error while updating medicine. Please try again");
      } else {
        this.toast.successMessage("Medicine updated successfully");
        $('#editMedModal').modal('hide');
        this.getMedicines(this.memCurDate, true);
      }
    });
  }

  deleteMed() {
    this.memberService.deleteMedicine(this.editMedObj.id, this.memCurDate).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage("Error while deleting medicine. Please try again");
      } else {
        this.toast.successMessage("Medicine deleted successfully");
        $('#delMedModal').modal('hide');
        this.getMedicines(this.memCurDate, true);
      }
    });
  }

  validateMed(obj: any) {
    let isValid = true;
    let times: any[] = [];
    for (let e of obj.medications) {
      if (e.dosage <= 0 || !/^\d+(\.\d+)?$/.test(e.dosage)) {
        this.toast.errorMessage("Dosage must be a valid number and greater than 0");
        isValid = false;
        break;
      } else if (e.quantity <= 0 || !/^\d+(\.\d+)?$/.test(e.quantity)) {
        this.toast.errorMessage("Quantity must be a valid number and greater than 0");
        isValid = false;
        break;
      } else if (!e.time || e.time.trim() == '') {
        this.toast.errorMessage("Please select time for all medicines");
        isValid = false;
        break;
      } else if (times.includes(e.time.trim())) {
        this.toast.errorMessage("Medicine times must be unique");
        isValid = false;
        break;
      } else {
        times.push(e.time.trim());
      }
    }
    return isValid;
  }

  // Update medicine status/time from list view
  updateMedStatus(row: any) {
    if (this.isFutureSelectedDate()) {
      this.toast.errorMessage("You can't change the med taken time and status for a future date."); 
      return;
    }
    if (!row.editableStatus || row.editableStatus.trim() === '') {
      this.toast.errorMessage("Please select status");
      return;
    }
    const selectedDate = formatDate(this.medSelectedDate, 'yyyy-MM-dd', 'en-US');
    const takenTime = row.editableTakenTime
      ? formatDate(new Date(`1970-01-01 ${row.editableTakenTime}`), 'hh:mm a', 'en-US')
      : '';

    const payload = {
      status: {
        recId: row.statusRecId,
        medId: row.medId,
        date: selectedDate,
        takenTime: takenTime,
        status: row.editableStatus
      }
    };

    this.memberService.updateMedicineStatus(payload).subscribe((response: any) => {
      if (response == 1) {
        this.toast.errorMessage("Error while updating status. Please try again");
      } else {
        this.toast.successMessage("Status updated successfully");
        this.getMedicines(formatDate(this.medSelectedDate, 'yyyy-MM-dd', 'en-US'), false);
        this.getMedicines(this.memCurDate, true);
      }
    });
  }

  onStatusDropdownInteraction(event: Event) {
    if (this.isFutureSelectedDate()) {
      event.preventDefault();
      event.stopPropagation();
      this.toast.errorMessage("You can't change the status for a future date.");
    }
  }

  isFutureSelectedDate(): boolean {
    if (!this.medSelectedDate) {
      return false;
    }
    const selected = new Date(this.medSelectedDate);
    selected.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selected.getTime() > today.getTime();
  }

  private convertToTimeInput(timeStr: string) {
    if (!timeStr) {
      return '';
    }
    const d = new Date(`1970-01-01 ${timeStr}`);
    return d.toTimeString().slice(0, 5);
  }

  // Add Medication Methods
  openAddMedModal() {
    this.resetAddMedForm();
    $('#addMedModal').modal('show');
  }

  resetAddMedForm() {
    this.newMedObj = {
      name: '',
      frequency: '',
      dosage: null,
      unit: '',
      startDate: null,
      medications: [{ time: '', quantity: null }]
    };
  }

  onAddFreqChange() {
    const freq = this.newMedObj.frequency;
    if (freq == 'Once daily' || freq == 'Weekly' || freq == 'Every 15 Days' || freq == 'Every 6 Months') {
      this.newMedObj.medications = [{ time: '', quantity: null }];
    } else if (freq == 'Twice daily') {
      this.newMedObj.medications = [
        { time: '', quantity: null },
        { time: '', quantity: null }
      ];
    } else if (freq == 'Thrice daily') {
      this.newMedObj.medications = [
        { time: '', quantity: null },
        { time: '', quantity: null },
        { time: '', quantity: null }
      ];
    }
  }

  addMedication() {
    // Validate fields
    if (!this.validateAddMed()) {
      return;
    }

    // Build the medications array with name, dosage, unit from newMedObj
    const medications = this.newMedObj.medications.map((med: any) => ({
      name: this.newMedObj.name,
      dosage: parseFloat(this.newMedObj.dosage),
      unit: this.newMedObj.unit,
      time: formatDate(new Date(`1970-01-01 ${med.time}`), 'hh:mm a', 'en-US'),
      quantity: parseFloat(med.quantity)
    }));

    const payload = {
      memberId: this.memberId,
      date: formatDate(this.newMedObj.startDate, 'yyyy-MM-dd', 'en-US'),
      frequency: this.newMedObj.frequency,
      medications: medications
    };

    this.memberService.addMedicine(payload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage("Error while adding medicine. Please try again");
      } else {
        this.toast.successMessage("Medicine added successfully");
        $('#addMedModal').modal('hide');
        this.resetAddMedForm();
        // Refresh the medicine list
        this.getMedicines(formatDate(this.medSelectedDate, 'yyyy-MM-dd', 'en-US'), false);
        this.getMedicines(this.memCurDate, true);
      }
    });
  }

  validateAddMed() {
    if (!this.newMedObj.name || this.newMedObj.name.trim() == '') {
      this.toast.errorMessage("Please enter medication name");
      return false;
    }
    if (!this.newMedObj.frequency || this.newMedObj.frequency == '') {
      this.toast.errorMessage("Please select frequency");
      return false;
    }
    if (!this.newMedObj.dosage || this.newMedObj.dosage <= 0) {
      this.toast.errorMessage("Please enter a valid dosage");
      return false;
    }
    if (!this.newMedObj.unit || this.newMedObj.unit == '') {
      this.toast.errorMessage("Please select unit");
      return false;
    }
    if (!this.newMedObj.startDate) {
      this.toast.errorMessage("Please select start tracking date");
      return false;
    }

    let times: any[] = [];
    for (let med of this.newMedObj.medications) {
      if (!med.time || med.time.trim() == '') {
        this.toast.errorMessage("Please select time for all doses");
        return false;
      }
      if (!med.quantity || med.quantity <= 0) {
        this.toast.errorMessage("Please select quantity for all doses");
        return false;
      }
      if (times.includes(med.time.trim())) {
        this.toast.errorMessage("Medicine times must be unique");
        return false;
      }
      times.push(med.time.trim());
    }
    return true;
  }
}
